<template>
  <div class="home">
    <van-sticky>
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="天下义门陈氏族谱大数据库"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
      <!--搜索-->
      <van-search v-model="searchQuery" placeholder="请输入支系名或庄名搜索" />
    </van-sticky>

    <!--列表-->
    <div style="height: 10px;"></div>
     <template v-for="item in filterItems()">
        <van-cell-group>
          <van-cell :title="item.name" is-link :url="item.url" v-if="item.url"/>
          <van-cell :title="item.name" is-link :to="'/home/detail?id='+item.id" v-else/>
        </van-cell-group>
     </template>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Home',
    data() {
        return {
          images: [
              {id:1,img: require('../../../public/static/tb1.png')}
          ],
          searchQuery:''
        };
    },
    computed: {
       ...mapState({
            list: state => state.root.clan_list
       })
    },
    methods: {
        ...mapActions(['requestClan']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.list) {
            return this.list.filter(item =>
              item.name.toLowerCase().includes(query)
            )
          }
        },
        onClickLeft() {
            this.$router.push({path: '/home'});
        }
    },
    mounted() {
      this.requestClan({"thit":this});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.home >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.home >>> .van-nav-bar__text {
  color: #fff;
}
.home >>> .van-nav-bar__title {
  color: #fff;
}
.home >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.home >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
